<template>
  <div class="passenger-wrapper octobus__box">
    <div class="octobus__columns">
      <div class="octobus__column is-paddingless">
        <PassengerTitle
          :passenger="passenger"
        />
      </div>
    </div>
    <div class="octobus__columns">
      <div class="octobus__column is-paddingless">
        <PassengerForm
          :id="id"
          :name="name"
          :lastName="lastName"
          :isDocNeed="isDocNeed"
          :passenger="passenger"
          @setPersonalInfo="setPersonalInfo"
        />
      </div>
    </div>
    <div class="is-divider is-hidden-mobile" :data-content="$t('passenger.ticket')"></div>
    <template v-for="(trip, index) in trips">
      <div :key="`${trip.raceId}race`" class="octobus__columns is-hidden-mobile is-hidden-desktop">
        <div class="octobus__column is-paddingless">
          <p class="is-size-5-touch">{{getRoute(trip.cityDepName, trip.cityArrName)}}</p>
        </div>
      </div>
      <div :key="trip.raceId" class="octobus__columns is-vcentered">
        <div class="octobus__column is-paddingless is-half-desktop is-half-tablet">
          <p>&nbsp;</p>
          <Bus
            v-if="trip.noPlaceNum === 0"
            :carrier="trip.carrier"
            :departure="trip.cityDepName"
            :arrived="trip.cityArrName"
            :places="getFreePlaces(trip.places, trip.raceId, false)"
            :raceId="trip.raceId"
            :busCapacity="trip.busCapacity"
            :busTemplate="trip.busTempl"
            :price="getTicketPrice(trip)"
            @selectedPlace="setPlace"
          />
          <Nobus
            v-else
            :places="getFreePlaces(trip.places, trip.raceId, true)"
            :departure="trip.cityDepName"
            :arrived="trip.cityArrName"
            :raceId="trip.raceId"
            :passenger="passenger"
            :price="getTicketPrice(trip)"
            @selectedPlace="setPlace"
          />
        </div>
        <div class="octobus__column is-paddingless-mobile">
          <Baggage
            :id="id"
            :raceId="trip.raceId"
            :priceBagg="trip.priceBagg"
            @baggage:selected="setBaggage"
          />
        </div>
        <div class="octobus__column is-paddingless">
          <Discount
            :id="id"
            :autoLgot="trip.autoLgot"
            :lgotes="trip.lgotes || []"
            :selectedCode="getLgot(trip.raceId)"
            :promoCode="getPromoCode(trip.raceId)"
            :raceId="trip.raceId"
            @selectedLgotes="setLgotes"
          />
        </div>
        <div class="octobus__column is-hidden-mobile is-paddingless is-narrow-tablet is-2-tablet is-1-desktop has-text-right-tablet">
          <p>&nbsp;</p>
          <Price :price="getTicketPrice(trip)" />
        </div>
      </div>
      <div class="octobus__columns" :key="`${trip.raceId}-desc`">
        <div class="octobus__column is-paddingless">
          <div class="octobus__field">
            <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" :for="`passenger__desc_${id}`">{{$t('passengerForm.description')}}</label>
            <p class="octobus__control">
              <input
                class="octobus__input is-medium"
                type="text"
                :placeholder="$t('passengerForm.description-placeholder')"
                :id="`passenger__desc_${id}`"
                :name="`passenger__desc_${id}`"
                v-model="descript"
              >
            </p>
          </div>
        </div>
      </div>
      <hr v-if="trips.length !== (index + 1)" :key="index" />
    </template>
  </div>
</template>

<script>
import PassengerTitle from './PassengerTitle';
import PassengerForm from './PassengerForm';
import Bus from './Bus';
import Nobus from './Nobus';
import Discount from './Discount';
import Price from './Price';
import Baggage from './Baggage';

export default {
  name: 'Passenger',
  components: {
    PassengerTitle,
    PassengerForm,
    Bus,
    Nobus,
    Discount,
    Price,
    Baggage,
  },
  inject: ['$validator'],
  props: {
    // порядковый номер пассажира
    passenger: {
      type: Number,
      default() {
        return 1;
      },
    },
    // все рейсы
    trips: {
      type: Array,
      required: true,
    },
    // выбранные места
    selectedPlace: {
      type: Object,
    },
  },
  data() {
    return {
      id: Math.random(),
      name: '', // имя пассажира
      lastName: '', // фамилия пассажира
      passport: '', // номер документа на право льготы
      descript: '', // примечание
      places: {},
      birthDay: '', // дата рождения пассажира
      citizen: '', // гражданство пассажира
      docType: '', // тип документа пассажира
      sex: '', // пол пассажира
    };
  },
  watch: {
    descript() {
      this.sendNewData();
    },
  },
  methods: {
    getRoute(departure, arrived) {
      return `${departure} - ${arrived}`;
    },
    setBaggage(value, raceId) {
      this.$set(this.places, raceId, { ...this.places[raceId], ...{ baggage: value } });
      this.$emit('onUpdatePrice', this.id, this.totalPrice);
      this.sendNewData();
    },
    setLgotes(value, raceId) {
      this.$set(this.places, raceId, { ...this.places[raceId], ...{ lgot: value.code } });
      this.$emit('onUpdatePrice', this.id, this.totalPrice);
      this.sendNewData();
    },
    getLgot(raceId) {
      return this.places[raceId] ? this.places[raceId].lgot : '';
    },
    setPromoCode(checkPromoCodeResponse) {
      const data = checkPromoCodeResponse.find(tripResult => tripResult.applicable);
      if (data) {
        this.$set(this.places, data.raceId, { ...this.places[data.raceId], ...{ lgot: data.autoLgot.code, promoCode: data.autoLgot } });
        this.$emit('onUpdatePrice', this.id, this.totalPrice);
      }
    },
    getPromoCode(raceId) {
      return this.places[raceId] ? this.places[raceId].promoCode : null;
    },
    setPlace(value, raceId) {
      this.$set(this.places, raceId, { ...this.places[raceId], ...{ place: value.num } }); // set free place
      this.$emit('onUpdatePlace', this.id, this.places);
      this.sendNewData();
    },
    setPersonalInfo(data) {
      this[data.field] = data.value;
      this.sendNewData();
    },
    sendNewData() {
      const { name, lastName, passport, birthDay, citizen, docType, sex, isDocNeed, descript } = this;

      this.$emit('onUpdatePersonalInfo', this.id, {
        name,
        lastName,
        passport,
        birthDay,
        descript,
        citizen,
        docType,
        sex,
        isDocNeed,
      });
    },
    getTicketPrice(trip) {
      const place = this.places[trip.raceId] || {};
      const baseFarePrice = Number(trip.pricePass);

      let farePrice = 0;
      if (place.lgot) {
        farePrice = [
          ...(trip.lgotes || []),
          ...(trip.autoLgot ? [trip.autoLgot] : []),
          ...(place.promoCode ? [place.promoCode] : []),
        ].find(lgot => lgot.code === place.lgot).price;
      } else {
        farePrice = baseFarePrice;
      }

      let baggageFee = 0;
      if (place.baggage && +trip.priceBagg > 0) {
        baggageFee = place.baggage * trip.priceBagg;
      }

      return {
        total: Number(farePrice) + baggageFee,
        withoutDiscount: Number(baseFarePrice) + baggageFee,
      };
    },
    getFreePlaces(places, raceId, autoSelect) {
      const selectedPlaces = this.selectedPlace;
      const id = this.id;
      let filteredPlaces = [];

      if (autoSelect) {
        // autoplace
        filteredPlaces = places.filter((place) => {
          const num = place.num;

          const isSelected = Boolean(Object.keys(selectedPlaces)
            .filter(passenger => selectedPlaces[passenger][raceId].place === num).length);

          return !isSelected;
        });
      } else {
        // bus
        filteredPlaces = places.filter((place) => {
          /* eslint-disable no-else-return */
          const num = place.num;

          const isSelected = Boolean(Object.keys(selectedPlaces).filter((passenger) => {
            if (passenger !== String(id) && selectedPlaces[passenger][raceId]) {
              return selectedPlaces[passenger][raceId].place === num;
            } else {
              return false;
            }
          }).length);

          return !isSelected;
        });
      }

      return filteredPlaces;
    },
  },
  computed: {
    isDocNeed() {
      return this.trips.some(trip => trip.countryFrom === 'RU' && trip.simpleForm !== 1);
    },
    totalPrice() {
      let total = 0;

      if (this.trips) {
        Object.keys(this.places).forEach((raceId) => {
          const trip = this.trips.find(cTrip => cTrip.raceId === raceId);
          total += this.getTicketPrice(trip).total;
        });

        return Number(total.toFixed(2));
      }

      return total;
    },
  },
  mounted() {
    this.$EventBus.$on('promocode__set', this.setPromoCode);
  },
  beforeDestroy() {
    this.$EventBus.$off('promocode__set', this.setPromoCode);
  },
};
</script>

<style scoped lang="scss">
#app, #auth {
  .is-divider {
    border-top-width: 0.01rem;

    &:after {
      padding: 0.3rem .8rem;
    }
  }

  @media only screen and (max-width : 768px) {
    .is-paddingless-mobile {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Passenger/Passenger.vue